<style scoped>
.zoezi-pdf-table {
    width: 100%;
}
.zoezi-pdf-table table {
    width: 100%;
    border-collapse: collapse;
}
.zoezi-pdf-table th {
    text-align: left;
    padding: 12px 16px;
    border-bottom: 2px solid rgba(0,0,0,.12);
    color: var(--z-primary);
    font-weight: 600;
}
.zoezi-pdf-table td {
    padding: 10px 16px;
    border-bottom: 1px solid rgba(0,0,0,.08);
}
.zoezi-pdf-table tr:hover td {
    background: rgba(0,0,0,.02);
}
.zoezi-pdf-table a {
    display: flex;
    align-items: center;
    gap: 8px;
    text-decoration: none;
    color: inherit;
}
.zoezi-pdf-table a:hover {
    color: var(--z-primary);
}
.zoezi-pdf-table .pdf-icon {
    flex-shrink: 0;
}
.zoezi-pdf-table .pdf-date {
    white-space: nowrap;
    color: rgba(0,0,0,.54);
    font-size: 0.875em;
}
.zoezi-pdf-table .pdf-empty {
    padding: 32px 16px;
    text-align: center;
    color: rgba(0,0,0,.38);
}
</style>

<template>
    <div class="zoezi-pdf-table">
        <table v-if="pdfs.length">
            <thead>
                <tr>
                    <th>{{ title || $translate('Document') }}</th>
                    <th v-if="showDate">{{ $translate('Date') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="pdf in pdfs" :key="pdf.key">
                    <td>
                        <a :href="getDownloadUrl(pdf)" target="_blank" rel="noopener">
                            <v-icon class="pdf-icon" :color="iconColor(pdf)">{{ iconFor(pdf) }}</v-icon>
                            {{ pdf.name }}
                        </a>
                    </td>
                    <td v-if="showDate" class="pdf-date">
                        {{ formatDate(pdf.created) }}
                    </td>
                </tr>
            </tbody>
        </table>
        <div v-else class="pdf-empty">
            {{ $translate('No documents available') }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'zoezi-pdf-table',
    zoezi: {
        title: 'Document list',
        icon: 'mdi-file-pdf-box'
    },
    props: {
        title: {
            title: 'Table heading',
            type: String,
            default: ''
        },
        showDate: {
            title: 'Show upload date',
            type: Boolean,
            default: true
        },
        showAllTypes: {
            title: 'Show all media files',
            type: Boolean,
            default: false
        },
        filterTags: {
            title: 'Filter by tags',
            type: Array,
            fulltype: 'select',
            typeinfo: {
                multiple: true,
                text: 'name',
                value: 'id',
                placeholder: 'Show all',
                getItems: () => window.$zoeziapi.get('/api/systemtag/get')
            },
            default: () => []
        },
        manageDocuments: {
            title: 'Manage documents',
            type: Number,
            fulltype: 'medialibrary',
            default: 0
        }
    },
    data: () => ({
        files: [],
        unsubscribe: []
    }),
    computed: {
        pdfs() {
            let result = this.showAllTypes ? this.files.slice() : this.files.filter(f => f.content_type === 'application/pdf');
            if (this.filterTags && this.filterTags.length) {
                result = result.filter(f =>
                    f.tags && f.tags.some(t => this.filterTags.includes(t.id))
                );
            }
            return result.sort((a, b) => -a.created.localeCompare(b.created));
        }
    },
    methods: {
        iconFor(file) {
            const ct = file.content_type || '';
            if (ct === 'application/pdf') return 'mdi-file-pdf-box';
            if (ct.startsWith('image/')) return 'mdi-file-image';
            if (ct.startsWith('video/')) return 'mdi-file-video';
            if (ct.startsWith('audio/')) return 'mdi-file-music';
            return 'mdi-file';
        },
        iconColor(file) {
            const ct = file.content_type || '';
            if (ct === 'application/pdf') return '#ef5350';
            if (ct.startsWith('image/')) return '#42a5f5';
            if (ct.startsWith('video/')) return '#ab47bc';
            if (ct.startsWith('audio/')) return '#66bb6a';
            return '#757575';
        },
        getDownloadUrl(file) {
            const hostname = this.$root.siteconfig?.hostname || location.hostname;
            return `${location.protocol}//${hostname}/api/utils/file/download?key=${file.key}&noredirect`;
        },
        formatDate(dateStr) {
            if (!dateStr) return '';
            return new Date(dateStr).toLocaleDateString();
        },
        loadFiles() {
            let args = {};
            if (this.filterTags && this.filterTags.length) {
                args.tags = this.filterTags.join(',');
            }
            this.$api.get('/api/utils/file/get_public_list', args).then(data => {
                this.files = Array.isArray(data) ? data.map(x => ({
                    name: x.name,
                    key: x.key,
                    created: x.created,
                    content_type: x.content_type,
                    tags: x.tags || []
                })) : [];
            }).catch(() => {
                this.files = [];
            });
        }
    },
    watch: {
        filterTags() {
            this.loadFiles();
        }
    },
    mounted() {
        this.loadFiles();
        this.unsubscribe.push(this.$api.subscribe({type: 'file', callback: () => this.loadFiles()}));
    },
    destroyed() {
        this.unsubscribe.forEach(x => x());
    }
}
</script>
